var map = {
	"./icons/icon-delete.svg": 343,
	"./icons/icon-edit.svg": 423,
	"./icons/icon-minus.svg": 488,
	"./icons/icon-moon.svg": 132,
	"./icons/icon-plus.svg": 58,
	"./icons/icon-reply.svg": 992,
	"./icons/icon-sun.svg": 569,
	"./images/avatars/image-amyrobson.png": 204,
	"./images/avatars/image-amyrobson.webp": 340,
	"./images/avatars/image-juliusomo.png": 728,
	"./images/avatars/image-juliusomo.webp": 56,
	"./images/avatars/image-maxblagun.png": 603,
	"./images/avatars/image-maxblagun.webp": 963,
	"./images/avatars/image-ramsesmiron.png": 595,
	"./images/avatars/image-ramsesmiron.webp": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;